const  API_URL = process.env.REACT_APP_API_URL;
const  ASSETS_URL = process.env.REACT_APP_ASSETS_URL;

const config = {
    apiUrl: API_URL,
    assetsUrl:ASSETS_URL,
}

export default config